import type {offersRouteApi} from "./-route-api";

import {listCustomerOffersSearchSchema} from "@project/application/sales/customer-offers";

export const offersSearchSchema = listCustomerOffersSearchSchema.extend({
  latestOnly: listCustomerOffersSearchSchema.shape.latestOnly.transform(() => true),
});
export type {ListCustomerOffersSearch as OffersSearch} from "@project/application/sales/customer-offers";
export type OffersNavigateFn = ReturnType<typeof offersRouteApi.useNavigate>;
